<template>
    <div>
        <Backer />
        
        <div class="fm-container">
            <div>
                <b-card-group deck>
                    <b-card
                        border-variant="primary"
                        header="Manage Inventory"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                    >
                        <!--b-card-text><button v-on:click="$router.push('/inventory_products/list/')">List Product Inventory</button></b-card-text-->

                        <b-card-text>
                            <button v-on:click="$router.push('/inventory_products/inv/')">Inventory</button>
                        </b-card-text>

                        <!-- <b-card-text><button v-on:click="$router.push('/inventory_products/request/')">Request Items</button></b-card-text> -->
<!-- 
                        <b-card-text>
                            <button v-on:click="$router.push('/inventory_products/trs/')">Transfers</button>
                        </b-card-text> -->

                        <!--b-card-text><button v-on:click="$router.push('/locations/list/')">List Locations</button></b-card-text-->
                        <!--b-card-text><button v-on:click="$router.push('/products/lookup/')">Lookup Product</button></b-card-text-->
                    </b-card>
                
                </b-card-group>
            </div>
        </div>

    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    export default {
        name: "ManageInventory",
        components: {Backer},
        data: function(){
            return {

            }
        },
        methods: {},
        created: function(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManageInventory.vue